module.exports = "<div class=\"{{class}}\">{{validationMessage | message | async}}</div>\n";